(function ($) {
  const duration = 300;

  /**
   * スライダー
   */
  function carouselSwiper() {
    const myOptions = {
      speed: 1000,
      loop: true,
      autoplay: 2000,
      centeredSlides: true,
      slidesPerView: 'auto',
    }

    const mainSlider = new Swiper('.js-gallery-carousel', myOptions);
  }

  /*
  * アコーディオン
  */
  function toggleInit() {
    if ($('.js-toggle').length) {
      $('.js-toggle').find('.js-toggle-label').each(function () {
        if (!$(this).hasClass('is-opened')) {
          $(this).siblings('.js-toggle-content').hide();
        }
        $(this).on('click', function () {
          if ($('+.js-toggle-content', this).not(':animated').length > 0) {
            $('+.js-toggle-content', this).slideToggle(duration);
            $(this).toggleClass('is-opened');
          }
          return false;
        });
      });
    };
 }

  /*
  * スクロールアニメーション
  */
  const delta = $(window).height() / 1.6;
  function scrollEffect() {
    $('.js-effect').each(function (i) {
      const elemPosition = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > elemPosition - delta) {
        $(this).addClass('is-visible');
      } else {
        $(this).removeClass('is-visible');
      }
    });
  }


  /**
   * ready
   */
  $(function() {
    carouselSwiper();
    toggleInit();
  });


  /**
   * scroll
   */
  $(window).scroll(() => {
    scrollEffect();
  });


  /**
   * load
   */
  $(window).on('load', () => {
      scrollEffect();
  });

})(window.jQuery);
